import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  background: var(--hn-canvas);
  display: block;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  width: 100%;
}

.hn-access {
  --hn-access-ink: #111411;
  --hn-access-paper: #f4f3ed;
  --hn-access-bamboo: #a8c85d;
  background: #fff;
  color: var(--hn-access-ink);
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(430px, 0.95fr);
  grid-template-rows: 64px minmax(0, 1fr);
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}

@supports (height: 100dvh) {
  .hn-access {
    height: 100dvh;
  }
}
.hn-access-header {
  align-items: center;
  background: var(--hn-access-ink);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  grid-column: 1/-1;
  grid-row: 1;
  padding: 0 clamp(20px, 2.4vw, 36px);
  position: relative;
  z-index: 4;
}

.hn-wordmark {
  color: #fff;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0.14em;
  line-height: 1;
}

.hn-wordmark::after {
  background: var(--hn-access-bamboo);
  border-radius: 50%;
  content: "";
  display: inline-block;
  height: 7px;
  margin-left: 11px;
  width: 7px;
}

.hn-access-hero {
  background: var(--hn-access-paper);
  color: var(--hn-access-ink);
  grid-column: 1;
  grid-row: 2;
  isolation: isolate;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.hn-access-hero::before {
  background-image: linear-gradient(rgba(17, 20, 17, 0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(17, 20, 17, 0.045) 1px, transparent 1px);
  background-size: 64px 64px;
  content: "";
  inset: 0;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent 90%);
  pointer-events: none;
  position: absolute;
}

.hn-access-hero::after {
  background: var(--hn-access-bamboo);
  bottom: 0;
  content: "";
  height: 6px;
  left: 0;
  position: absolute;
  right: 0;
}

.hn-hero-title {
  display: flex;
  flex-direction: column;
  font-size: clamp(48px, 5vw, 72px);
  font-weight: 900;
  inset: 32px 36px 30px;
  justify-content: space-between;
  letter-spacing: -0.075em;
  line-height: 0.92;
  margin: 0;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.hn-hero-title span,
.hn-hero-title strong {
  display: block;
  opacity: 0;
  transform: translateY(12px);
}

.hn-hero-title strong {
  align-self: flex-end;
  color: var(--hn-access-ink);
  font-size: 1.05em;
  position: relative;
}

.hn-hero-title strong::after {
  background: var(--hn-access-bamboo);
  bottom: -0.08em;
  content: "";
  height: 0.16em;
  left: -0.05em;
  position: absolute;
  right: -0.07em;
  z-index: -1;
}

.hn-access.is-ready .hn-hero-title span {
  animation: hn-title-enter 0.34s 0.06s ease-out forwards;
}

.hn-access.is-ready .hn-hero-title strong {
  animation: hn-title-enter 0.34s 0.14s ease-out forwards;
}

.hn-smash-stage {
  aspect-ratio: 1;
  left: 50%;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, calc(-50% + 10px));
  width: min(60vh, 62%);
  z-index: 2;
}

.hn-access.is-ready .hn-smash-stage {
  animation: hn-stage-enter 0.3s 0.12s ease-out forwards;
}

.hn-smash-stage::after {
  border: 2px solid var(--hn-access-ink);
  border-radius: 50%;
  content: "";
  height: 76px;
  left: 68%;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 57%;
  transform: scale(0.2);
  width: 76px;
  z-index: 3;
}

.hn-access.is-ready .hn-smash-stage::after {
  animation: hn-impact-ring 1.9s 0.26s linear forwards;
}

.hn-smash-sprite {
  aspect-ratio: 1;
  background-image: url("/assets/brand/hannom-smash-sprite-v2.webp");
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 300% 200%;
  contain: paint;
  height: 100%;
  transform-origin: 50% 64%;
  width: 100%;
}

.hn-access.is-ready .hn-smash-sprite {
  animation: hn-smash-frames 1.9s 0.26s steps(1, end) forwards, hn-smash-shake 1.9s 0.26s linear forwards;
}

.hn-access-dock {
  align-content: start;
  background: #fff;
  border-left: 1px solid var(--hn-line);
  color: var(--hn-access-ink);
  display: grid;
  grid-column: 2;
  grid-row: 2;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 32px clamp(32px, 3.5vw, 52px);
  position: relative;
  z-index: 3;
}

.hn-access-dock::before {
  background: var(--hn-access-bamboo);
  content: "";
  height: 4px;
  left: clamp(32px, 3.5vw, 52px);
  position: absolute;
  top: 0;
  width: 58px;
}

.hn-dock-heading,
.hn-access-form,
.hn-recovery-ready {
  margin: 0 auto;
  max-width: 430px;
  opacity: 0;
  transform: translateY(6px);
  width: 100%;
}

.hn-access.is-ready .hn-dock-heading,
.hn-access.is-ready .hn-access-form,
.hn-access.is-ready .hn-recovery-ready {
  animation: hn-dock-content-enter 0.28s 0.1s ease-out forwards;
}

.hn-access.is-ready .hn-access-form,
.hn-access.is-ready .hn-recovery-ready {
  animation-delay: 0.15s;
}

.hn-dock-heading {
  margin-bottom: 22px;
}

.hn-dock-heading h1 {
  font-size: clamp(28px, 2.4vw, 34px);
  font-weight: 800;
  letter-spacing: -0.05em;
  line-height: 1;
  margin: 0;
}

.hn-auth-links {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 18px;
  margin-top: 10px;
}

.hn-auth-links button,
.hn-auth-back {
  background: transparent;
  border: 0;
  color: var(--hn-muted-strong);
  font-size: 14px;
  font-weight: 700;
  min-height: 44px;
  padding: 0;
  text-decoration: underline;
  text-decoration-color: var(--hn-line-strong);
  text-underline-offset: 5px;
}

.hn-auth-links button:hover,
.hn-auth-back:hover {
  color: var(--hn-access-ink);
  text-decoration-color: var(--hn-access-bamboo);
}

.hn-auth-back {
  margin-top: 12px;
}

.hn-setup-status {
  align-items: center;
  background: #fff7e7;
  border: 1px solid #c89539;
  border-radius: 9px;
  color: #6f4708;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  gap: 10px;
  justify-content: space-between;
  line-height: 1.4;
  margin-top: 14px;
  padding: 9px 10px 9px 12px;
}

.hn-setup-status button {
  background: #fff;
  border: 1px solid #9b6b1d;
  border-radius: 7px;
  color: #5f3b05;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 800;
  min-height: 44px;
  padding: 0 11px;
}

.hn-setup-status button:disabled {
  opacity: 0.62;
}

.hn-access-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
}

.hn-access-field {
  min-width: 0;
}

.hn-access-field + .hn-access-field {
  margin-top: 14px;
}

.hn-access-field > label,
.hn-access-field__label label {
  color: var(--hn-access-ink);
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.hn-access-field > label {
  margin-bottom: 9px;
}

.hn-access-field__label {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.hn-password-toggle {
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 800;
  min-height: 44px;
  min-width: 44px;
  padding: 0 0 0 10px;
}

.hn-password-toggle:hover {
  color: var(--hn-access-ink);
}

.hn-field-control {
  position: relative;
}

.hn-field-control input {
  background: var(--hn-paper-soft);
  border: 1px solid #7f897f;
  border-radius: 10px;
  color: var(--hn-access-ink);
  font-size: 16px;
  font-weight: 500;
  height: 50px;
  outline: 0;
  padding: 0 14px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), box-shadow 0.16s var(--hn-ease);
  width: 100%;
}

.hn-field-control input::placeholder {
  color: #5f685f;
  font-weight: 500;
  opacity: 1;
}

.hn-field-control input:focus {
  background: #fff;
  border-color: var(--hn-accent-deep);
  box-shadow: 0 0 0 3px rgba(168, 200, 93, 0.18);
}

.hn-field-control input:focus-visible {
  outline: 3px solid #2359cb;
  outline-offset: 2px;
}

.hn-field-control input[aria-invalid=true] {
  border-color: var(--hn-danger);
  box-shadow: 0 0 0 3px rgba(217, 76, 58, 0.12);
}

.hn-access-error-slot {
  min-height: 34px;
  padding-top: 8px;
}

.hn-access-error {
  color: #a93425;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  margin: 0;
}

.hn-access-notice {
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  margin: 0;
}

.hn-access-submit {
  align-items: center;
  background: var(--hn-access-bamboo);
  border: 1px solid #91ad4e;
  border-radius: 10px;
  color: var(--hn-accent-ink);
  display: flex;
  font-size: 14px;
  font-weight: 800;
  height: 50px;
  justify-content: space-between;
  padding: 0 17px;
  transition: background-color 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
  width: 100%;
}

.hn-access-submit:hover:not(:disabled) {
  background: var(--hn-accent-hover);
  transform: translateY(-1px);
}

.hn-access-submit:disabled {
  cursor: wait;
  opacity: 0.64;
}

.hn-submit-icon {
  color: var(--hn-accent-ink);
  height: 16px;
  position: relative;
  width: 19px;
}

.hn-submit-icon::before,
.hn-submit-icon::after {
  content: "";
  position: absolute;
  transition: transform 0.16s var(--hn-ease);
}

.hn-submit-icon::before {
  border-top: 2px solid currentColor;
  right: 0;
  top: 7px;
  width: 18px;
}

.hn-submit-icon::after {
  border-right: 2px solid currentColor;
  border-top: 2px solid currentColor;
  height: 7px;
  right: 0;
  top: 3px;
  transform: rotate(45deg);
  width: 7px;
}

.hn-access-submit:hover:not(:disabled) .hn-submit-icon::before {
  transform: translateX(3px);
}

.hn-access-submit:hover:not(:disabled) .hn-submit-icon::after {
  transform: translateX(3px) rotate(45deg);
}

.hn-submit-icon.is-loading {
  animation: hn-access-spin 0.75s linear infinite;
  border: 2px solid rgba(38, 50, 15, 0.24);
  border-radius: 50%;
  border-top-color: var(--hn-accent-ink);
  height: 17px;
  width: 17px;
}

.hn-submit-icon.is-loading::before,
.hn-submit-icon.is-loading::after {
  display: none;
}

.hn-recovery-ready > p {
  color: var(--hn-muted-strong);
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 14px;
}

.hn-recovery-ready > code {
  background: var(--hn-access-ink);
  border-radius: 10px;
  color: #fff;
  display: block;
  font: 800 clamp(17px, 2vw, 24px)/1.2 ui-monospace, monospace;
  letter-spacing: 0.09em;
  overflow-wrap: anywhere;
  padding: 16px 18px;
  text-align: center;
}

.hn-recovery-actions {
  display: grid;
  gap: 9px;
  grid-template-columns: 1fr 1.35fr;
  margin-top: 14px;
}

.hn-secondary-action {
  background: #fff;
  border: 1px solid var(--hn-line-strong);
  border-radius: 10px;
  color: var(--hn-access-ink);
  font-size: 14px;
  font-weight: 800;
  height: 52px;
  padding: 0 14px;
}

.hn-secondary-action:hover {
  background: var(--hn-paper-soft);
}

.hn-recovery-ready > small {
  color: var(--hn-accent-deep);
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-top: 11px;
}

@keyframes hn-title-enter {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes hn-stage-enter {
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
@keyframes hn-smash-frames {
  0%, 13% {
    background-position: 0 0;
  }
  13.01%, 27% {
    background-position: 50% 0;
  }
  27.01%, 42% {
    background-position: 100% 0;
  }
  42.01%, 55% {
    background-position: 0 100%;
  }
  55.01%, 73% {
    background-position: 50% 100%;
  }
  73.01%, 100% {
    background-position: 100% 100%;
  }
}
@keyframes hn-smash-shake {
  0%, 26%, 34%, 54%, 63%, 100% {
    transform: translate(0, 0) rotate(0);
  }
  28%, 56% {
    transform: translate(-4px, 2px) rotate(-0.7deg);
  }
  30%, 58% {
    transform: translate(4px, -1px) rotate(0.7deg);
  }
  32%, 60% {
    transform: translate(-2px, 1px) rotate(-0.3deg);
  }
}
@keyframes hn-impact-ring {
  0%, 26%, 34%, 54%, 63%, 100% {
    opacity: 0;
    transform: scale(0.2);
  }
  28%, 56% {
    opacity: 0.8;
    transform: scale(0.45);
  }
  33%, 61% {
    opacity: 0;
    transform: scale(1.35);
  }
}
@keyframes hn-dock-content-enter {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes hn-access-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (min-width: 761px) and (min-height: 720px) {
  .hn-access:not(.is-expanded) .hn-access-dock {
    align-content: center;
  }
}
@media (min-width: 761px) and (min-height: 900px) {
  .hn-access.is-expanded .hn-access-dock {
    align-content: center;
  }
}
@media (min-width: 761px) and (max-height: 700px) {
  .hn-access {
    grid-template-rows: 56px minmax(0, 1fr);
  }
  .hn-access-dock {
    align-content: start;
    padding-bottom: 24px;
    padding-top: 24px;
  }
  .hn-dock-heading {
    margin-bottom: 22px;
  }
  .hn-hero-title {
    font-size: clamp(38px, 5vw, 62px);
    bottom: 28px;
    top: 28px;
  }
  .hn-smash-stage {
    width: min(55vh, 58%);
  }
}
@media (max-width: 980px) {
  .hn-access {
    grid-template-columns: minmax(0, 1fr) minmax(390px, 0.92fr);
  }
  .hn-smash-stage {
    width: min(56vh, 76%);
  }
  .hn-hero-title {
    font-size: clamp(48px, 6.4vw, 64px);
    inset: 34px 32px 34px;
  }
  .hn-access-dock {
    padding-left: 34px;
    padding-right: 34px;
  }
}
@media (max-width: 760px) {
  :host {
    overflow: auto;
  }
  .hn-access {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: calc(54px + env(safe-area-inset-top)) 158px auto;
    height: auto;
    min-height: 100dvh;
    overflow: visible;
  }
  .hn-access.is-expanded {
    grid-template-rows: calc(54px + env(safe-area-inset-top)) 92px auto;
  }
  .hn-access-header {
    grid-column: 1;
    grid-row: 1;
    padding: env(safe-area-inset-top) 16px 0;
  }
  .hn-wordmark {
    font-size: 16px;
  }
  .hn-access-hero {
    grid-column: 1;
    grid-row: 2;
  }
  .hn-hero-title {
    font-size: clamp(30px, 9vw, 38px);
    inset: 15px 16px;
    line-height: 0.9;
  }
  .hn-hero-title strong {
    font-size: 1em;
  }
  .hn-smash-stage {
    left: 66%;
    top: 52%;
    width: min(48vw, 188px);
  }
  .hn-smash-stage::after {
    height: 54px;
    width: 54px;
  }
  .hn-access.is-expanded .hn-hero-title {
    font-size: clamp(24px, 7.5vw, 30px);
    bottom: 10px;
    top: 10px;
  }
  .hn-access.is-expanded .hn-smash-stage {
    width: min(34vw, 132px);
  }
  .hn-access-dock {
    align-content: start;
    border-left: 0;
    border-top: 1px solid var(--hn-line);
    grid-column: 1;
    grid-row: 3;
    min-height: calc(100dvh - 212px - env(safe-area-inset-top));
    overflow: visible;
    padding: 22px 16px calc(24px + env(safe-area-inset-bottom));
  }
  .hn-access.is-expanded .hn-access-dock {
    min-height: calc(100dvh - 146px - env(safe-area-inset-top));
  }
  .hn-access-dock::before {
    left: 16px;
  }
  .hn-dock-heading {
    margin-bottom: 18px;
  }
  .hn-dock-heading h1 {
    font-size: 27px;
  }
  .hn-auth-links {
    gap: 0 16px;
    margin-top: 8px;
  }
  .hn-access-field + .hn-access-field {
    margin-top: 13px;
  }
  .hn-access-error-slot {
    min-height: 28px;
  }
  .hn-access-submit {
    height: 50px;
  }
  .hn-recovery-actions {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 380px) {
  .hn-access-header,
  .hn-access-dock {
    padding-left: 14px;
    padding-right: 14px;
  }
  .hn-access-dock::before {
    left: 14px;
  }
  .hn-hero-title {
    left: 14px;
    right: 14px;
  }
}
@media (max-width: 760px) and (max-height: 700px) {
  .hn-access {
    grid-template-rows: calc(52px + env(safe-area-inset-top)) 132px auto;
  }
  .hn-access.is-expanded {
    grid-template-rows: calc(52px + env(safe-area-inset-top)) 82px auto;
  }
  .hn-smash-stage {
    width: min(42vw, 160px);
  }
  .hn-hero-title {
    font-size: clamp(27px, 8vw, 34px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .hn-access.is-ready .hn-hero-title span,
  .hn-access.is-ready .hn-hero-title strong,
  .hn-access.is-ready .hn-smash-stage,
  .hn-access.is-ready .hn-smash-stage::after,
  .hn-access.is-ready .hn-smash-sprite,
  .hn-access.is-ready .hn-dock-heading,
  .hn-access.is-ready .hn-access-form,
  .hn-access.is-ready .hn-recovery-ready,
  .hn-submit-icon.is-loading {
    animation: none;
  }
  .hn-access.is-ready .hn-hero-title span,
  .hn-access.is-ready .hn-hero-title strong {
    opacity: 1;
    transform: none;
  }
  .hn-access.is-ready .hn-smash-stage {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
  .hn-access.is-ready .hn-smash-stage::after {
    display: none;
  }
  .hn-access.is-ready .hn-smash-sprite {
    background-position: 0 0;
    transform: none;
  }
  .hn-access.is-ready .hn-dock-heading,
  .hn-access.is-ready .hn-access-form,
  .hn-access.is-ready .hn-recovery-ready {
    opacity: 1;
    transform: none;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        confirm_password: '',
        setup_code: ''
    };

    public recoveryData: any = {
        email: '',
        recovery_code: '',
        new_password: '',
        confirm_password: ''
    };

    public mode: string = 'login';
    public isReady: boolean = false;
    public isSubmitting: boolean = false;
    public showPassword: boolean = false;
    public showSignupPassword: boolean = false;
    public showRecoveryPassword: boolean = false;
    public formError: string = '';
    public errorField: string = '';
    public formNotice: string = '';
    public recoveryCode: string = '';
    public signupAvailable: boolean = false;
    public setupStatusFailed: boolean = false;
    public isCheckingSetup: boolean = false;

    public get modeTitle(): string {
        if (this.mode === 'signup') return '회원가입';
        if (this.mode === 'recover') return '비밀번호 재설정';
        if (this.mode === 'recovery-ready') return '가입 완료';
        return '로그인';
    }

    @HostListener('window:beforeunload', ['$event'])
    public protectRecoveryCode(event: BeforeUnloadEvent) {
        if (!this.recoveryCode) return;
        event.preventDefault();
        event.returnValue = '';
    }

    @HostListener('window:popstate')
    public async restoreModeFromHistory() {
        if (this.isSubmitting) return;

        if (this.recoveryCode) {
            const leave = window.confirm('복구 코드를 아직 저장하지 않았습니다. 이 화면을 나갈까요?');
            if (!leave) {
                this.syncModeUrl('signup', false);
                return;
            }
            this.recoveryCode = '';
        }

        let mode = this.modeFromLocation();
        if (mode === 'signup' && !this.signupAvailable) mode = 'login';
        await this.setMode(mode, false);
    }

    public canDeactivate(): boolean {
        if (!this.recoveryCode) return true;
        return window.confirm('복구 코드를 아직 저장하지 않았습니다. 이 화면을 나갈까요?');
    }

    public async ngOnInit() {
        await this.service.init();
        const authenticated = await this.service.auth.check();

        if (authenticated) {
            location.href = "/dashboard";
            return;
        }

        await this.loadSetupStatus();
        const requestedMode = this.modeFromLocation();
        this.mode = requestedMode === 'signup' && !this.signupAvailable ? 'login' : requestedMode;
        if (requestedMode === 'signup' && !this.signupAvailable && !this.setupStatusFailed) {
            this.syncModeUrl('login', true);
        }
        this.updateDocumentTitle();
        this.isReady = true;
        await this.service.render();
        setTimeout(() => this.focusMode(this.mode), 0);
    }

    public async loadSetupStatus() {
        if (this.isCheckingSetup) return;
        this.isCheckingSetup = true;
        this.setupStatusFailed = false;
        if (this.isReady) await this.service.render();

        try {
            const { code, data } = await wiz.call('setup_status');
            if (code !== 200) throw new Error('setup status');
            this.signupAvailable = !!data?.signup_available;
        } catch (error) {
            this.signupAvailable = false;
            this.setupStatusFailed = true;
        } finally {
            this.isCheckingSetup = false;
            if (this.isReady) await this.service.render();
        }
    }

    public async retrySetupStatus() {
        await this.loadSetupStatus();
        if (!this.setupStatusFailed && this.signupAvailable && this.modeFromLocation() === 'signup') {
            await this.setMode('signup', false);
        }
    }

    public async setMode(mode: string, updateHistory: boolean = true) {
        if (this.isSubmitting) return;
        if (mode === 'signup' && !this.signupAvailable) return;

        const email = String(this.data.email || this.signupData.email || this.recoveryData.email || '').trim();
        this.mode = mode;
        if (updateHistory) this.syncModeUrl(mode);
        this.updateDocumentTitle();
        this.formError = '';
        this.errorField = '';
        this.formNotice = '';
        this.showPassword = false;
        this.showSignupPassword = false;
        this.showRecoveryPassword = false;

        if (mode === 'signup') {
            this.signupData = { name: '', email, password: '', confirm_password: '', setup_code: '' };
        }

        if (mode === 'recover') {
            this.recoveryData = { email, recovery_code: '', new_password: '', confirm_password: '' };
        }

        if (mode === 'login') {
            this.data.email = email;
            this.data.password = '';
            this.recoveryCode = '';
        }

        await this.service.render();
        setTimeout(() => this.focusMode(mode), 0);
    }

    private focusMode(mode: string) {
        const ids: any = {
            login: 'hn-access-email',
            signup: 'hn-signup-name',
            recover: 'hn-recovery-email'
        };
        const target = document.getElementById(ids[mode]);
        if (target) target.focus();
    }

    private loginDestination(): string {
        const candidate = new URLSearchParams(location.search).get('returnTo') || '/dashboard';
        try {
            const destination = new URL(candidate, location.origin);
            if (destination.origin !== location.origin) return '/dashboard';
            return destination.pathname + destination.search + destination.hash;
        } catch (error) {
            return '/dashboard';
        }
    }

    public async togglePassword(scope: string) {
        if (scope === 'signup') this.showSignupPassword = !this.showSignupPassword;
        else if (scope === 'recover') this.showRecoveryPassword = !this.showRecoveryPassword;
        else this.showPassword = !this.showPassword;
        await this.service.render();
    }

    public async clearError(field: string = '') {
        if (!this.formError) return;
        if (this.errorField && field && this.errorField !== field) return;
        this.formError = '';
        this.errorField = '';
        await this.service.render();
    }

    private async showError(message: string, field: string = '') {
        this.formError = message;
        this.errorField = field || this.inferErrorField(message);
        await this.service.render();

        const ids: any = {
            login_email: 'hn-access-email',
            login_password: 'hn-access-password',
            signup_name: 'hn-signup-name',
            signup_email: 'hn-signup-email',
            signup_password: 'hn-signup-password',
            signup_confirm: 'hn-signup-confirm',
            signup_setup_code: 'hn-signup-setup-code',
            recovery_email: 'hn-recovery-email',
            recovery_code: 'hn-recovery-code',
            recovery_password: 'hn-recovery-password',
            recovery_confirm: 'hn-recovery-confirm'
        };
        setTimeout(() => {
            const target = document.getElementById(ids[this.errorField]);
            target?.focus({ preventScroll: true });
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target?.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        }, 0);
    }

    private responseMessage(data: any, fallback: string): string {
        return (data && data.message) || (typeof data === 'string' ? data : fallback);
    }

    private modeFromLocation(): string {
        const mode = new URLSearchParams(location.search).get('mode');
        return mode === 'signup' || mode === 'recover' ? mode : 'login';
    }

    private syncModeUrl(mode: string, replace: boolean = false) {
        const url = new URL(location.href);
        if (mode === 'signup' || mode === 'recover') url.searchParams.set('mode', mode);
        else url.searchParams.delete('mode');
        const destination = url.pathname + url.search + url.hash;
        if (replace) history.replaceState({ authMode: mode }, '', destination);
        else history.pushState({ authMode: mode }, '', destination);
    }

    private updateDocumentTitle() {
        document.title = this.modeTitle + ' | HANNOM';
    }

    private isValidEmail(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    private passwordBytes(password: string): number {
        return new TextEncoder().encode(password).length;
    }

    private inferErrorField(message: string): string {
        if (!message) return '';
        if (message.includes('이메일 형식')) {
            if (this.mode === 'signup') return 'signup_email';
            if (this.mode === 'recover') return 'recovery_email';
            return 'login_email';
        }
        if (message.includes('설정 코드')) return 'signup_setup_code';
        if (message.includes('복구 코드')) return 'recovery_code';
        if (message.includes('비밀번호가 일치') || message.includes('새 비밀번호가 일치')) {
            return this.mode === 'recover' ? 'recovery_confirm' : 'signup_confirm';
        }
        if (message.includes('비밀번호가 너무') || message.includes('8자 이상')) {
            if (this.mode === 'signup') return 'signup_password';
            if (this.mode === 'recover') return 'recovery_password';
            return 'login_password';
        }
        return '';
    }

    public async login() {
        if (this.isSubmitting) return;

        const user = {
            email: String(this.data.email || '').trim().toLowerCase(),
            password: String(this.data.password || '')
        };

        if (!user.email) {
            await this.showError("이메일을 입력해주세요.", 'login_email');
            return;
        }

        if (!this.isValidEmail(user.email)) {
            await this.showError("이메일 형식을 확인해주세요.", 'login_email');
            return;
        }

        if (!user.password) {
            await this.showError("비밀번호를 입력해주세요.", 'login_password');
            return;
        }

        if (this.passwordBytes(user.password) > 72) {
            await this.showError("비밀번호가 너무 깁니다.", 'login_password');
            return;
        }

        this.formError = '';
        this.errorField = '';
        this.formNotice = '';
        this.isSubmitting = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("login", user);

            if (code === 200) {
                location.href = this.loginDestination();
                return;
            }

            await this.showError(this.responseMessage(data, "로그인에 실패했습니다."));
        } catch (error) {
            await this.showError("로그인 요청을 완료하지 못했습니다.");
        } finally {
            this.isSubmitting = false;
            await this.service.render();
        }
    }

    public async signup() {
        if (this.isSubmitting) return;

        const payload = {
            name: String(this.signupData.name || '').trim(),
            email: String(this.signupData.email || '').trim().toLowerCase(),
            password: String(this.signupData.password || ''),
            confirm_password: String(this.signupData.confirm_password || ''),
            setup_code: String(this.signupData.setup_code || '').trim()
        };

        if (!payload.name) { await this.showError('이름을 입력해주세요.', 'signup_name'); return; }
        if (!payload.email) { await this.showError('이메일을 입력해주세요.', 'signup_email'); return; }
        if (!this.isValidEmail(payload.email)) { await this.showError('이메일 형식을 확인해주세요.', 'signup_email'); return; }
        if (!payload.password) { await this.showError('비밀번호를 입력해주세요.', 'signup_password'); return; }
        if (!payload.confirm_password) { await this.showError('비밀번호를 한 번 더 입력해주세요.', 'signup_confirm'); return; }
        if (!payload.setup_code) { await this.showError('초기 설정 코드를 입력해주세요.', 'signup_setup_code'); return; }

        if (payload.password.length < 8) {
            await this.showError("비밀번호는 8자 이상이어야 합니다.", 'signup_password');
            return;
        }

        if (this.passwordBytes(payload.password) > 72) {
            await this.showError("비밀번호가 너무 깁니다.", 'signup_password');
            return;
        }

        if (payload.password !== payload.confirm_password) {
            await this.showError("비밀번호가 일치하지 않습니다.", 'signup_confirm');
            return;
        }

        this.formError = '';
        this.errorField = '';
        this.isSubmitting = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("signup", payload);

            if (code === 200 && data && data.recovery_code) {
                this.data.email = payload.email;
                this.recoveryCode = data.recovery_code;
                this.signupData.password = '';
                this.signupData.confirm_password = '';
                this.signupData.setup_code = '';
                this.mode = 'recovery-ready';
                this.syncModeUrl('signup', true);
                this.updateDocumentTitle();
                this.signupAvailable = false;
                setTimeout(() => document.getElementById('hn-recovery-ready')?.focus(), 0);
                return;
            }

            await this.showError(this.responseMessage(data, "회원가입을 완료하지 못했습니다."));
        } catch (error) {
            await this.showError("회원가입 요청을 완료하지 못했습니다.");
        } finally {
            this.isSubmitting = false;
            await this.service.render();
        }
    }

    public async resetPassword() {
        if (this.isSubmitting) return;

        const payload = {
            email: String(this.recoveryData.email || '').trim().toLowerCase(),
            recovery_code: String(this.recoveryData.recovery_code || '').trim().toUpperCase(),
            new_password: String(this.recoveryData.new_password || ''),
            confirm_password: String(this.recoveryData.confirm_password || '')
        };

        if (!payload.email) { await this.showError('이메일을 입력해주세요.', 'recovery_email'); return; }
        if (!this.isValidEmail(payload.email)) { await this.showError('이메일 형식을 확인해주세요.', 'recovery_email'); return; }
        if (!payload.recovery_code) { await this.showError('복구 코드를 입력해주세요.', 'recovery_code'); return; }
        if (!payload.new_password) { await this.showError('새 비밀번호를 입력해주세요.', 'recovery_password'); return; }
        if (!payload.confirm_password) { await this.showError('새 비밀번호를 한 번 더 입력해주세요.', 'recovery_confirm'); return; }

        if (payload.new_password.length < 8) {
            await this.showError("새 비밀번호는 8자 이상이어야 합니다.", 'recovery_password');
            return;
        }

        if (this.passwordBytes(payload.new_password) > 72) {
            await this.showError("새 비밀번호가 너무 깁니다.", 'recovery_password');
            return;
        }

        if (payload.new_password !== payload.confirm_password) {
            await this.showError("새 비밀번호가 일치하지 않습니다.", 'recovery_confirm');
            return;
        }

        this.formError = '';
        this.errorField = '';
        this.isSubmitting = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("reset_password", payload);

            if (code === 200) {
                this.data.email = payload.email;
                this.data.password = '';
                this.recoveryData = { email: '', recovery_code: '', new_password: '', confirm_password: '' };
                this.mode = 'login';
                this.syncModeUrl('login', true);
                this.updateDocumentTitle();
                this.formNotice = "비밀번호가 변경됐습니다. 로그인 후 새 복구 코드를 발급해주세요.";
                setTimeout(() => this.focusMode('login'), 0);
                return;
            }

            await this.showError(this.responseMessage(data, "비밀번호를 재설정하지 못했습니다."));
        } catch (error) {
            await this.showError("비밀번호 재설정 요청을 완료하지 못했습니다.");
        } finally {
            this.isSubmitting = false;
            await this.service.render();
        }
    }

    public async copyRecoveryCode() {
        if (!this.recoveryCode) return;

        try {
            await navigator.clipboard.writeText(this.recoveryCode);
            this.formNotice = "복구 코드를 복사했습니다.";
        } catch (error) {
            this.formNotice = "복구 코드를 직접 복사해 안전하게 보관해주세요.";
        }

        await this.service.render();
    }

    public async finishRecoverySetup() {
        this.recoveryCode = '';
        await this.setMode('login');
    }
}

export default PageAccessComponent;